/**
 * BackToInvoices: the back control on the two month-end pages Invoices
 * opens, Pre-billing for every client and Payroll hours. Where the person
 * came from when the page was opened from inside Olive (the browser's
 * history, which keeps the month Invoices was showing), else Invoices
 * itself (a deep link, a refresh, an outside referrer).
 */
import type { ReactNode } from 'react';
import { BackControl } from '@/components/BackControl';

export function BackToInvoices({ tenantSlug }: { tenantSlug: string }): ReactNode {
  return (
    <BackControl
      label="Invoices"
      ariaLabel="Back to invoices"
      to={`/t/${encodeURIComponent(tenantSlug)}/invoices`}
      testId="back-to-invoices"
      className="mb-4"
    />
  );
}
